export interface InterviewRecordingModalProps {
  open: boolean;
  onClose: () => void;
  interviewId?: string;
  candidateName?: string;
  jobRole?: string;
  date?: string;
  duration?: string;
}

export interface InterviewRecordingPlayerProps {
  src: string;
  poster?: string;
  autoPlay?: boolean;
  onEnded?: () => void;
  className?: string;
}

export interface PlayerState {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  bufferedEnd: number;
  volume: number;
  isMuted: boolean;
  playbackRate: number;
  isFullscreen: boolean;
  isLoading: boolean;
  isBuffering: boolean;
  error: string | null;
}

export interface PlayerControlsProps {
  showControls: boolean;
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  bufferedEnd: number;
  volume: number;
  isMuted: boolean;
  playbackRate: number;
  isFullscreen: boolean;
  isSpeedOpen: boolean;
  onTogglePlay: () => void;
  onSkip: (seconds: number) => void;
  onVolumeChange: (volume: number) => void;
  onToggleMute: () => void;
  onRateChange: (rate: number) => void;
  onSpeedOpenChange: (open: boolean) => void;
  onToggleFullscreen: () => void;
  onSeek: (targetTime: number) => void;
  onScrubbingChange: (isScrubbing: boolean) => void;
}

export interface PlayerOverlayProps {
  isLoading: boolean;
  isBuffering: boolean;
  error: string | null;
  isPlaying: boolean;
  onPlay: () => void;
  onRetry: () => void;
}

export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2] as const;